import { Cluster, ClusterDisplayStatus } from '@cast/types';

import { isKentManagedCluster } from '@cast/shared-cluster-context-data-access';

export const isClusterAssignable = (
  cluster: Cluster,
  excludeKentManaged: boolean = true
): boolean => {
  const hasUnnassignableStatus = [
    ClusterDisplayStatus.DISCONNECTED,
    ClusterDisplayStatus.FAILED,
  ].includes(cluster.displayStatus);

  return (
    !hasUnnassignableStatus &&
    (!excludeKentManaged || !isKentManagedCluster(cluster))
  );
};

export const onlyAssignableClusters = <T extends Cluster>(
  clusters: T[],
  excludeKentManaged: boolean = true
): T[] =>
  clusters.filter((cluster) =>
    isClusterAssignable(cluster, excludeKentManaged)
  );
